import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@chakra-ui/react';
import ParticipantUI from './participantUI';

const ParticipantsPane = ({ members }) => {
  const containerRef = useRef();
  const [width, setWidth] = useState(100);

  useLayoutEffect(() => {
    const marginX = 4;
    const marginY = 4;
    const aspectRatio = 4 / 3;
    const height = containerRef.current.clientHeight - marginY;
    const width = Math.round(height * aspectRatio) + marginX;
    setWidth(width);
  });

  const me = members.find((m) => m.isSelf);
  if (me) {
    members = members.filter((m) => m !== me);
  }

  return (
    <Box overflowX="auto" overflowY="hidden" height="100%" bg="black">
      <Flex height="100%" width="max-content" ref={containerRef}>
        {me && (
          <>
            <Box m="4px" height="100%" width={width + 'px'}>
              <Box position="relative" height="calc(100% - 8px)">
                <Box position="absolute" top="0" left="0" bottom="0" right="0">
                  <ParticipantUI useVideo={true} member={me} isSmall={true} />
                </Box>
              </Box>
            </Box>
            <Box my="2" mx="2px" width="1px" bg="#4a4a4a"></Box>
          </>
        )}
        {!!members.length &&
          members.map((member) => (
            <Box key={member.id} m="4px" height="100%" width={width + 'px'}>
              <Box position="relative" height="calc(100% - 8px)">
                <Box position="absolute" top="0" left="0" bottom="0" right="0">
                  <ParticipantUI useVideo={true} member={member} isSmall={true} />
                </Box>
              </Box>
            </Box>
          ))}
      </Flex>
    </Box>
  );
};

ParticipantsPane.propTypes = {
  members: PropTypes.array.isRequired,
};

export default ParticipantsPane;
